const disconnected = (target, propertyKey) => {
  const disconnectedCallback = target.disconnectedCallback ?? (() => undefined);

  Reflect.defineProperty(target, "disconnectedCallback", {
    value() {
      Reflect.apply(disconnectedCallback, this, arguments);
      return this[propertyKey](...arguments);
    },
    writable: true,
  });
};

export default disconnected;
